import React from "react";

import Image from "next/image";

import { cx } from "@/lib/tailwind-utils";

const AIBadge: React.FC<{ size?: number; className?: string }> = ({
  size = 15,
  className,
}) => {
  return (
    <Image
      src="/logos/decoda-favicon.ico"
      className={cx("mr-1 shrink-0 select-none", className)}
      alt="AI Badge"
      width={size}
      height={size}
    />
  );
};

export default AIBadge;
